import analytics from 'util/analytics';
import * as moment from 'moment-timezone'
const initState = {
    authId: "",
    studioIds: [],
    reservations: [],
    purchases: [],
    ownedChallenges: [],
    ownedOfferings: {},
    userData: {},
    loading: false,
    saving: false,
    error: null,
    success: null,
}

export const SET_ACCESS_RIGHTS = "SET_ACCESS_RIGHTS"
export const SET_USER = "SET_USER"
export const SET_USER_LOADING = "SET_USER_LOADING"
export const SET_USER_SAVING = "SET_USER_SAVING"
export const SET_USER_ERROR = "SET_USER_ERROR"
export const SET_USER_SAVE_SUCCESS = "SET_USER_SAVE_SUCCESS"
export const SET_USER_RESERVATIONS = "SET_USER_RESERVATIONS"
export const ADD_USER_RESERVATION = "ADD_USER_RESERVATION"
export const CANCEL_USER_RESERVATION = "CANCEL_USER_RESERVATION"
export const SET_USER_PURCHASES = "SET_USER_PURCHASES"
export const RESET_USER = "RESET_USER"

const userReducer = (state = initState, action) => {
    switch (action.type) {
        case RESET_USER:
            return initState
        case SET_ACCESS_RIGHTS:
            state.authId = action.authId;
            state.studioIds = action.studioIds;
            break;
        case SET_USER:

        console.log("Updating user DATA: ", action.userData)
            return {
                ...state,
                userData: {
                    ...action.userData
                },
                loading: false
            }
        case SET_USER_LOADING:
            state.loading = action.loading;
            break;
        case SET_USER_SAVING:
            state.saving = action.saving;
            break;
        case SET_USER_ERROR:
            state.error = action.error;
            break;
        case SET_USER_SAVE_SUCCESS:
            state.success = action.success
            break;
        case SET_USER_RESERVATIONS:
            return {
                ...state,
                reservations: action.reservations
            }
        case ADD_USER_RESERVATION:
            return {
                ...state,
                reservations: [...state.reservations].concat(action.reservation)
            }
        case CANCEL_USER_RESERVATION:
            return {
                ...state,
                reservations: state.reservations.map(item => {
                    if (item.id === action.id) {
                        return {
                            ...item,
                            canceled: true
                        }
                    }
                    return item
                })
            }
            // const resIndex = newState.reservations.findIndex((val) => val.id === action.id)
            // if (resIndex !== null) {
            //     console.log("found the one to cancel")
            //     newState.reservations[resIndex] = {
            //         ...newState.reservations[resIndex],
            //         canceled: true
            //     }
            // }
            // return newState
        case SET_USER_PURCHASES:
            console.log("USER PURCHASES: ", action.purchases)
            const NOW = moment().unix()
            return {
                ...state,
                purchases: action.purchases,
                ownedChallenges: action.purchases.reduce((map, obj) => {
                    if (obj.expires < NOW) {
                        return map
                    }
                    if (obj.offering?.challenges) {
                        obj.offering.challenges.forEach(challengeId => {
                            map[challengeId] = obj
                        })
                    }
                    return map
                }, {}),
                ownedOfferings: action.purchases.reduce((map, obj)=> {
                    if (obj.expires < moment().unix()) {
                        return map
                    }
                    if (obj.offering?.id) {
                        map[obj.offering.id] = obj
                    }
                    return map
                },{})
            }
            
        default:
            break;
    }

    return state
}

export default userReducer